import {useQuery} from '@github-ui/react-query'
import {makeSelectDataFromQueryData} from '@github-ui/react-core/future/main-query'
import {useRuntimeEnvironment} from '@github-ui/ssr-utils/use-runtime-environment'
import {pullRequestsCommitsRoute} from '../../routes/commits-route'
import {usePullRequestBasePath} from '../../stores/layout-selectors'
import type {CommitsRoutePayload} from '../../routes/route-payload-types'
import {useLayoutQuery} from '../../page-data/loaders/use-layout-query'
import {invalidateOnAliveSubscription} from '@github-ui/use-invalidate-on-alive-update/subscription'
import type {PullRequestAliveData} from '../../hooks/use-refetch-on-alive-update'

const selectCommits = makeSelectDataFromQueryData<CommitsRoutePayload>()
const didGitUpdate = (data: PullRequestAliveData) => Boolean(data.event_updates?.git_updated)

export function useOverviewCommits({enabled}: {enabled: boolean}) {
  const basePath = usePullRequestBasePath()
  const {aliveChannels} = useLayoutQuery().data
  const {isServer} = useRuntimeEnvironment()
  const queryKey = pullRequestsCommitsRoute.queries.mainQuery.makeQueryKey({pathname: `${basePath}/commits`})
  return useQuery({
    ...pullRequestsCommitsRoute.buildQueryOptions('mainQuery', queryKey),
    select: selectCommits,
    enabled: !isServer && enabled,
    subscription: (_data, context) =>
      invalidateOnAliveSubscription<PullRequestAliveData>(aliveChannels.pullRequest, context, {filter: didGitUpdate}),
  })
}
